import config from "@frameworks/web/config/domain";
var report1 = config.oldWebUrl + "reports/myreports/subscription";
export var HeaderEnum;
(function (HeaderEnum) {
    HeaderEnum["PRODUCT_EQUITY"] = "/products/equity";
    HeaderEnum["FIXED_INCOME"] = "/products/fixed-income/bonds";
    HeaderEnum["FIXED_INCOME_NCD"] = "/";
    HeaderEnum["FIXED_INCOME_CORPFD"] = "/products/corporate-fd";
    HeaderEnum["FIXED_INCOME_54ACBONDS"] = "/products/capital-gains-bonds";
    HeaderEnum["ALTERNATIVE_SPMLD"] = "/products/mld";
    HeaderEnum["ALTERNATIVE_SGB"] = "/products/sgb";
    HeaderEnum["MANGED_PORTFOLIO_MF"] = "/products/managed-portfolio/mutualfunds";
    HeaderEnum["MANGED_PORTFOLIO_ETF"] = "products/managed-portfolio/etf";
    HeaderEnum["MANGED_PORTFOLIO_SMALLCASE"] = "/";
    HeaderEnum["MANGED_PORTFOLIO_PICKRIGHT"] = "/";
    HeaderEnum["CORP_FD"] = "/";
    HeaderEnum["SGB"] = "/sgb";
    HeaderEnum["CORP_FD_PRODUCT"] = "/products/corporate-fd";
    HeaderEnum["CORP_FD_ORDERBOOK"] = "/corporate-fd/orderbook";
    HeaderEnum["SEC_MARKET_EQUITY"] = "/products/equity";
    HeaderEnum["SEC_MARKET_CURRENCY"] = "/";
    HeaderEnum["INSURANCE_GENERAL"] = "/insurance";
    HeaderEnum["INSURANCE_LIFE"] = "/insurance";
    HeaderEnum["EQUITY"] = "/markets/equity";
    HeaderEnum["EQUITY_DRIVING_MARKET"] = "/markets/equity?sectionName=drivingMarket";
    HeaderEnum["EQUITY_STOCKUPGRADE_DOWNGRADE"] = "/markets/equity?sectionName=stocksUnderSurveillanceWrap";
    HeaderEnum["EQUITY_INSIDER_TRADING"] = "/markets/equity?sectionName=insiderTradingAndSast";
    HeaderEnum["EQUITY_EVENTCALENDAR"] = "/event-calendar/CALENDAR_HOME";
    HeaderEnum["EQUITY_EVENTCALENDAR_ALL_EVENTS"] = "/event-calendar/ALL_EVENTS_LISTING";
    HeaderEnum["FUTURE"] = "/markets/futures";
    HeaderEnum["FUTURE_SPOT_COMPARATIVE"] = "/markets/futures?sectionName=futures-spotcomparative";
    HeaderEnum["FUTURE_OI_ANALYSIS"] = "/markets/futures?sectionName=futures-openinterestanalysis";
    HeaderEnum["FUTURE_SECURITY_FNO_BAN"] = "/markets/futures?sectionName=futures-securitiesinfandoban";
    HeaderEnum["OPTIONS"] = "/markets/options";
    HeaderEnum["OPTIONS_CHAIN_TOOL"] = "/option-chain-tool";
    HeaderEnum["OPTIONS_CHAIN"] = "/markets/options?sectionName=callput-tableblock";
    HeaderEnum["OPTIONS_OICHART"] = "/markets/options?sectionName=oi-charts";
    HeaderEnum["OPTIONS_ADVANCED_CHAIN"] = "/markets/options?sectionName=AdvancedOptionTools";
    HeaderEnum["MUTUAL_FUND"] = "/markets/mutualFunds";
    HeaderEnum["MUTUAL_FUND_TOPPERFORMING"] = "/markets/mutualFunds?sectionName=TopPerformingFunds";
    HeaderEnum["MUTUAL_FUND_IDEASFORINVESTMENT"] = "/markets/mutualFunds?sectionName=IdeasforInvestment";
    HeaderEnum["MUTUAL_FUND_GROWTH_CALCULATOR"] = "/markets/mutualFunds?sectionName=MfCalculator";
    HeaderEnum["MUTUAL_FUND_EXPLORE_ALL_FUNDS"] = "/markets/mutualFunds?sectionName=ExploreAllFunds";
    HeaderEnum["OTHERS_ETF"] = "/markets/etfs";
    HeaderEnum["OTHERS_OFS_BUYS_RIGHTS"] = "/corporate-action";
    HeaderEnum["SECONDARY_NCD"] = "/markets/ncds";
    HeaderEnum["OTHERS_CORP_FD"] = "/corporate-fd";
    HeaderEnum["IPO"] = "/markets/primaryMarket/ipo";
    HeaderEnum["IPO_LIVES"] = "/markets/primaryMarket/ipo?sectionName=live-ipos";
    HeaderEnum["IPO_TOBE_ANNOUNCED"] = "/markets/primaryMarket/ipo?sectionName=upcoming-ipos";
    HeaderEnum["IPO_UPCOMING"] = "/markets/primaryMarket/ipo?sectionName=upcoming-ipos";
    HeaderEnum["IPO_LISTING_PERFORMANCE"] = "/markets/primaryMarket/ipo?sectionName=ListingPerformance";
    HeaderEnum["NCD"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["NCD_IPO_LIVES"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["NCD_IPO_UPCOMING"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["NFO"] = "/markets/primaryMarket/nfo";
    HeaderEnum["NFO_LIVES"] = "/markets/primaryMarket/nfo";
    HeaderEnum["NFO_UPCOMING"] = "/markets/primaryMarket/nfo";
    HeaderEnum["NFO_LISTING_PERFORMANCE"] = "/markets/primaryMarket/nfo";
    HeaderEnum["OPTION_CHAIN_INSIDER_SAST"] = "/";
    HeaderEnum["OPTION_CHAIN_MARGIN_CALCULATOR"] = "/margin-calculator";
    HeaderEnum["OPTION_CHAIN_EVENT_CALENDAR"] = "/event-calendar";
    HeaderEnum["ALERTS_TRADING_AREA"] = "/watchlist";
    HeaderEnum["ALERTS_LIVE_NEWS"] = "/live-news";
    HeaderEnum["ALERTS_ALPHA"] = "/";
    HeaderEnum["DASHBOARD_REPORT"] = "/reports/dashboard-report";
    HeaderEnum["HOLDINGS_REPORT"] = "/reports/holding";
    HeaderEnum["PROFITLOSS_REPORT"] = "/reports/profitandloss";
    HeaderEnum["TAX_REPORT"] = "/reports/tax";
    HeaderEnum["TRANSACTION_HISTORY_REPORT"] = "/reports/transaction-history";
    HeaderEnum["MARGINS_REPORT"] = "/reports/margin-report";
    HeaderEnum["LEADGER_REPORT"] = "/reports/ledger-report";
    HeaderEnum["COMMODITY"] = "/commodity/:symbol";
    HeaderEnum["ALERTS"] = "/alerts";
    HeaderEnum["PLACEORDER"] = "/";
    HeaderEnum["MARGIN_FILES"] = "/margin-files";
    HeaderEnum["AUTHORIZE_TO_SELL"] = "/authorize-sell";
    HeaderEnum["PLEDGE"] = "/epledges";
    HeaderEnum["FUND_TRANSFER"] = "/fund-transfer";
    HeaderEnum["ORDERBOOK"] = "/orderbook";
    HeaderEnum["SEE_MARGIN"] = "/";
    HeaderEnum["WATCHLIST"] = "/watchlist";
    HeaderEnum["EVOTING"] = "/";
    HeaderEnum["EDIS"] = "/edis";
    HeaderEnum["EQUITY_SIP_BOOK"] = "/";
    HeaderEnum["MF_SIP_BOOK"] = "/";
    HeaderEnum["SEARCH"] = "/search";
    HeaderEnum["POSITION"] = "/newreports/positions";
    // CONTRACT_NOTE = "/reports/contract-notes-statements",
    // DP_BILLS = "/reports/dp-bills",
    // DP_INTEREST = "/reports/dp-interest",
    // SUBSCRIPTION_HISTORY = "/reports/subscription-history",
    // new links
    HeaderEnum["FIXED_INCOME_NCD_NFO"] = "/products/fixed-income/bonds";
    HeaderEnum["FIXED_INCOME_SECONDARYPRODUCTS"] = "/products/fixed-income/debentures";
    HeaderEnum["FIXED_INCOME_CORPORATE_FD"] = "/products/fixed-income/CorpFD";
    HeaderEnum["FIXED_INCOME_54EC_BONDS"] = "/products/fixed-income/54ec-bonds";
    HeaderEnum["FIXED_INCOME_RBI_BONDS"] = "/products/fixed-income/rbi-bonds";
    HeaderEnum["FIXED_INCOME_SGB"] = "/products/fixed-income/sgb";
    HeaderEnum["SECONDARY_MARKETS_EQUITY"] = "/products/exchange-traded/equity";
    HeaderEnum["SECONDARY_MARKETS_CURRENCY"] = "/products/exchange-traded/currency";
    HeaderEnum["SECONDARY_MARKETS_COMMODITY"] = "/products/exchange-traded/commodity";
    HeaderEnum["SECONDARY_MARKETS_SUB_FEE_INFINITY"] = "/products/exchange-traded/infinity-subscription";
    HeaderEnum["MANAGED_PORTFOLIO_AIF"] = "/products/managed-portfolio/aif";
    HeaderEnum["MANAGED_PORTFOLIO_PMS"] = "/products/managed-portfolio/pms";
    HeaderEnum["MANAGED_PORTFOLIO_MUTUALFUNDS"] = "/products/managed-portfolio/mutualfunds";
    HeaderEnum["MANAGED_PORTFOLIO_ETF"] = "/products/managed-portfolio/etf";
    HeaderEnum["MANAGED_PORTFOLIO_SP"] = "/products/managed-portfolio/structured-product";
    HeaderEnum["SOLUTION_LIFE_INSURANCE"] = "/products/insurance/life-insurance";
    HeaderEnum["SOLUTION_GENERAL_INSURANCE"] = "/products/insurance/general-insurance";
    HeaderEnum["MARKET_EQUITY"] = "/markets/equity";
    HeaderEnum["MARKET_FUTURES"] = "/markets/futures";
    HeaderEnum["MARKET_OPTIONS"] = "/markets/options";
    HeaderEnum["MARKET_MUTUALfUNDS"] = "/markets/mutualFunds";
    HeaderEnum["MARKET_ETF"] = "/markets/etfs";
    HeaderEnum["PRIMARYMARKETS_IPO"] = "/markets/primaryMarket/ipo";
    HeaderEnum["PRIMARYMARKETS_NCD_IPO"] = "/markets/primaryMarket/ncd-ipo";
    HeaderEnum["PRIMARYMARKETS_NFO"] = "/markets/primaryMarket/nfo";
    // RESOURCES_OPTIONCHAIN = "/markets/options",
    HeaderEnum["RESOURCES_LIVENEWS"] = "/live-news";
    HeaderEnum["OTHEROFFERING_PICKRIGHT"] = "/";
    HeaderEnum["OTHEROFFERING_SMALLCASE"] = "/";
    HeaderEnum["SUPPORT_CONTACT"] = "/";
    HeaderEnum["SUPPORT_ACCOUNTOPENING_STATUS"] = "";
    HeaderEnum["SUPPORT_NOTICE_FORMS_FORMATS"] = "/important-messages";
    HeaderEnum["REPORT_DASHBORAD"] = "reports?reportName=Dashboard";
    HeaderEnum["REPORT_HOLDING"] = "/newreports/holding";
    HeaderEnum["REPORT_PROFIT_LOSS"] = "reports?reportName=ProfitandLoss";
    HeaderEnum["REPORT_TAX"] = "reports?reportName=Tax";
    HeaderEnum["REPORT_TRANSACTION_HISTORY"] = "";
    HeaderEnum["REPORT_MARGINS"] = "";
    HeaderEnum["REPORT_LEDGER"] = "reports?reportName=otherReports&tab=ledger-report";
    HeaderEnum["REPORT_CONTRACT_NOTES"] = "reports?reportName=otherReports&tab=contract-notes";
    HeaderEnum["REPORT_EQUITY_SIP"] = "";
    HeaderEnum["REPORT_MF_SIP"] = "";
    HeaderEnum["REPORT_PENDING_LTCG"] = "";
    HeaderEnum["REPORT_PAYMENT_INTERACTION"] = "reports?reportName=otherReports&tab=delayed-payment-interest";
    HeaderEnum["REPORT_DPBILLS"] = "reports?reportName=otherReports&tab=dpbills";
    HeaderEnum["REPORT_SUBSCRIPTIONFEES"] = "reports?reportName=otherReports&tab=subscription-history";
    HeaderEnum["TRANSACT_PLACE_ORDER"] = "";
    HeaderEnum["TRANSACT_fUNDTRANSFER"] = "";
    HeaderEnum["TRANSACT_POSITION"] = "";
    HeaderEnum["TRANSACT_ORDER_BOOK"] = "";
    HeaderEnum["TRANSACT_SEE_MARGINS"] = "";
    HeaderEnum["TRANSACT_AUTHORIZETOSELL"] = "";
    HeaderEnum["TRANSACT_PLEDGE"] = "";
    HeaderEnum["TRANSACT_E_VOTING"] = "";
    HeaderEnum["TRANSACT_MARGIN_FILES"] = "";
    HeaderEnum["CONTRACT_NOTE"] = "reports?reportName=otherReports&tab=contract-notes";
    HeaderEnum["DP_BILLS"] = "reports?reportName=otherReports&tab=dpbills";
    HeaderEnum["DP_INTEREST"] = "reports?reportName=otherReports&tab=delayed-payment-interest";
    HeaderEnum["SUBSCRIPTION_HISTORY"] = "reports?reportName=otherReports&tab=subscription-history";
})(HeaderEnum || (HeaderEnum = {}));
